/** Cosine distance in [0, 2] for L2-normalized vectors → display percent (higher = closer). */
export function cosineDistanceToSimilarityPercent(cosineDistance: number): number {
  return Math.max(0, Math.min(100, (1 - cosineDistance / 2) * 100));
}
